import { EmailRecordsService } from '@weave/schema-gen-ts/dist/schemas/email/records/v1/records_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaEmailRecordsV1Service = bindHTTP(EmailRecordsService);
